module.exports = ".fill {\n  color: red; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/order-form-driver-driver-unassign/order-form-driver-driver-unassign.component.scss
// module id = ./src/app/dashboard/order-form-driver-driver-unassign/order-form-driver-driver-unassign.component.scss
// module chunks = main